var React = require('react');

function FacebookGray (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-310 -599)"},[React.createElement("rect",{"width":"22","height":"22","transform":"translate(310 599)","fill":"#fff","key":0}),React.createElement("path",{"d":"M13.4,21V12.8h2.765l.411-3.209H13.4V7.548c0-.926.258-1.56,1.587-1.56h1.684V3.128A22.108,22.108,0,0,0,14.2,3a3.861,3.861,0,0,0-4.122,4.231V9.586H7.332V12.8h2.753V21H13.4Z","transform":"translate(308.668 598)","fill":"#b1b1b1","key":1})]));
}

FacebookGray.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = FacebookGray;

FacebookGray.default = FacebookGray;
